<template>
  <span>
    <v-chip
      v-if="params && isClickable"
      :color="params.value > 0 ? `green lighten-4` : `red lighten-3`"
      @click="onClick"
      >{{ params.value }}</v-chip
    >
    <v-chip
      v-else-if="params"
      :color="params.value > 0 ? `green lighten-4` : `red lighten-3`"
      >{{ params.value }}</v-chip
    >
  </span>
</template>

<script>
export default {
  name: "allocation-number-label",
  computed: {
    isClickable() {
      // Check if this is a "used" allocation with value > 0
      return (
        this.params &&
        this.params.context &&
        this.params.context.displayValue === "taken" &&
        this.params.value > 0
      );
    },
  },
  methods: {
    onClick() {
      if (
        this.params &&
        this.params.context &&
        this.params.context.onAllocationClick
      ) {
        this.params.context.onAllocationClick(
          this.params.data,
          this.params.column.colId
        );
      }
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/plugins/allocations/AllocationNumberLabel.vue